import { createContext } from 'react';

export type PortalContainer = React.FC<{ children?: React.ReactNode }>;

export const PortalContainerContext = createContext<
  PortalContainer | undefined
>(undefined);
